var map = {
	"./39-fintech-highlighted-chile": [
		"b87d",
		"chunk-9e98288a"
	],
	"./39-fintech-highlighted-chile.vue": [
		"b87d",
		"chunk-9e98288a"
	],
	"./asocupa-2023": [
		"9595",
		"chunk-70d96317"
	],
	"./asocupa-2023.vue": [
		"9595",
		"chunk-70d96317"
	],
	"./canaldedenuncias": [
		"73bb",
		"chunk-3c98e940"
	],
	"./canaldedenuncias.vue": [
		"73bb",
		"chunk-3c98e940"
	],
	"./ceptine-top-five": [
		"ee83",
		"chunk-3992e27e"
	],
	"./ceptine-top-five.vue": [
		"ee83",
		"chunk-3992e27e"
	],
	"./ceptinel-GoGlobal-2021": [
		"6517",
		"chunk-33738042"
	],
	"./ceptinel-GoGlobal-2021.vue": [
		"6517",
		"chunk-33738042"
	],
	"./ceptinel-present-financial-services-forum": [
		"a360",
		"chunk-59a09615"
	],
	"./ceptinel-present-financial-services-forum.vue": [
		"a360",
		"chunk-59a09615"
	],
	"./compliance-monitor": [
		"04fa",
		"chunk-2d0a42b5"
	],
	"./compliance-monitor.vue": [
		"04fa",
		"chunk-2d0a42b5"
	],
	"./congreso-colombia": [
		"689b",
		"chunk-29ddaeaf"
	],
	"./congreso-colombia.vue": [
		"689b",
		"chunk-29ddaeaf"
	],
	"./df-news": [
		"2350",
		"chunk-a7c4127e"
	],
	"./df-news.vue": [
		"2350",
		"chunk-a7c4127e"
	],
	"./estrategia-news": [
		"ec68",
		"chunk-6171f9a2"
	],
	"./estrategia-news.vue": [
		"ec68",
		"chunk-6171f9a2"
	],
	"./hemispheric-congress": [
		"4d3a",
		"chunk-52ad19dc"
	],
	"./hemispheric-congress.vue": [
		"4d3a",
		"chunk-52ad19dc"
	],
	"./innova-startup-week-2023": [
		"ee7a",
		"chunk-b64a4160"
	],
	"./innova-startup-week-2023.vue": [
		"ee7a",
		"chunk-b64a4160"
	],
	"./insurance-Fraud-Monitoring": [
		"9eec",
		"chunk-2d0f11e0"
	],
	"./insurance-Fraud-Monitoring.vue": [
		"9eec",
		"chunk-2d0f11e0"
	],
	"./insurtech-latam-forum-2023": [
		"dfad",
		"chunk-5e9f7e65"
	],
	"./insurtech-latam-forum-2023.vue": [
		"dfad",
		"chunk-5e9f7e65"
	],
	"./internal-bank-fraud-monitoring": [
		"6638",
		"chunk-2d0cfe1b"
	],
	"./internal-bank-fraud-monitoring.vue": [
		"6638",
		"chunk-2d0cfe1b"
	],
	"./mapa-regtech-mundo": [
		"af8d",
		"chunk-86ad4006"
	],
	"./mapa-regtech-mundo.vue": [
		"af8d",
		"chunk-86ad4006"
	],
	"./market-market": [
		"5769",
		"chunk-5917119e"
	],
	"./market-market.vue": [
		"5769",
		"chunk-5917119e"
	],
	"./mcKinsey-startup-accelerator": [
		"9659",
		"chunk-6dd4e0da"
	],
	"./mcKinsey-startup-accelerator.vue": [
		"9659",
		"chunk-6dd4e0da"
	],
	"./mckinsey": [
		"e4fc",
		"chunk-2d225a62"
	],
	"./mckinsey.vue": [
		"e4fc",
		"chunk-2d225a62"
	],
	"./media-presence": [
		"4a90",
		"chunk-40bbb6e2"
	],
	"./media-presence.vue": [
		"4a90",
		"chunk-40bbb6e2"
	],
	"./mexico-business-round-2023": [
		"1b06",
		"chunk-51a1d68f"
	],
	"./mexico-business-round-2023.vue": [
		"1b06",
		"chunk-51a1d68f"
	],
	"./new-logo": [
		"384a",
		"chunk-0f3e001d"
	],
	"./new-logo.vue": [
		"384a",
		"chunk-0f3e001d"
	],
	"./partnership-cab": [
		"8edc",
		"chunk-65156735"
	],
	"./partnership-cab.vue": [
		"8edc",
		"chunk-65156735"
	],
	"./partnership-cyberventures": [
		"bc20",
		"chunk-2d21a735"
	],
	"./partnership-cyberventures.vue": [
		"bc20",
		"chunk-2d21a735"
	],
	"./portalminero": [
		"7f51",
		"chunk-0a4ba4a0"
	],
	"./portalminero.vue": [
		"7f51",
		"chunk-0a4ba4a0"
	],
	"./radio-bio-bio": [
		"3a23",
		"chunk-050e36bc"
	],
	"./radio-bio-bio.vue": [
		"3a23",
		"chunk-050e36bc"
	],
	"./research-market": [
		"2614",
		"chunk-8078407e"
	],
	"./research-market.vue": [
		"2614",
		"chunk-8078407e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "59db";
module.exports = webpackAsyncContext;